import apiService from './api';
import { Company, CreateCompanyData, UpdateCompanyData, GetCompanyResponse } from '../types/companyTypes';

class CompanyService {
  async getCompanies(): Promise<Company[]> {
    const response = await apiService.get<Company[]>('/companies');
    return response.data;
  }

  async getCompany(id: string): Promise<Company> {
    const response = await apiService.get<Company>(`/companies/${id}`);
    return response.data;
  }

  async createCompany(data: CreateCompanyData): Promise<Company> {
    const response = await apiService.post<Company>('/companies', data);
    return response.data;
  }

  async updateCompany(data: UpdateCompanyData): Promise<Company> {
    const { id, ...updateData } = data;
    const response = await apiService.put<Company>(`/companies/${id}`, updateData);
    return response.data;
  }

  async deleteCompany(id: string): Promise<void> {
    await apiService.delete(`/companies/${id}`);
  }

  async toggleCompanyStatus(id: string): Promise<Company> {
    const response = await apiService.patch<Company>(`/companies/${id}/toggle-status`);
    return response.data;
  }
}

export const companyService = new CompanyService();
export default companyService;